module.exports={account_link_complete_message:"已完成 Nexon 帳號的連動。"};